export enum PartyType {
  CLIENT = <any>'CLIENT',
  PROPERTY = <any>'PROPERTY',
  AGENCY = <any>'AGENCY'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/party-type.ts